var map = {
	"./gallery_img_1.jpeg": 5617,
	"./gallery_img_2.jpeg": 1507,
	"./gallery_img_3.jpeg": 9554,
	"./gallery_img_4.jpeg": 2559,
	"./gallery_img_5.jpeg": 3889,
	"./gallery_img_6.jpeg": 3602,
	"./gallery_img_8.jpeg": 7398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3514;